import { gsap } from "gsap";
export default ()=>{    
    const popupOpenButtons = document.querySelectorAll('[data-open-modal]');

    popupOpenButtons.forEach(button =>{
        const popup = document.querySelector('[data-popup="'+ button.dataset.openModal + '"]');
        button.addEventListener('click', ()=>{
            popup.classList.add('active');
            document.body.style.overflow = "hidden"
        })
        
        const closePopup = popup.querySelectorAll('[data-modal-close]');

        closePopup.forEach(close =>{
            close.addEventListener('click', ()=>{
                popup.classList.remove('active');
                document.body.style.overflow = "auto"
            })
        })
    })
}
